module.exports = __webpack_public_path__ + "static/media/image1.da9efa87.png";